import axios from "axios";
import store from "../redux/app/store";
import { getBaseUrl } from "./apiSettings";
import tokenVerification from "./tokenVerification";

const jsonFormatAuth = () => {
  // Verify token is valid. Log out if token is invalid.
  const isTokenValid = tokenVerification();
  if (!isTokenValid) {
    return null;
  }

  const storeData = store.getState();
  const userData = storeData?.userState?.userData;

  const axiosInstance = axios.create({
    baseURL: getBaseUrl(),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${userData?.access}`,
    },
  });

  return axiosInstance;
};

export default jsonFormatAuth;
